import { createContext, useContext } from "react";

import type { PlanCode, User } from "../../types/api";

export interface AuthState {
  user: User | null;
  tenantPlan: PlanCode | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthState | undefined>(undefined);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}